import { render } from "./DateTabletFormComponentDetails.vue?vue&type=template&id=5ad222ee"
import script from "./DateTabletFormComponentDetails.vue?vue&type=script&lang=js"
export * from "./DateTabletFormComponentDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__